import { useMutation } from '@tanstack/react-query';
import api from '../../services/api';

export const MUTATION_KEY_TOTEM_SEND_COMMAND = 'TOTEM_SEND_COMMAND';

interface UseSendTotemCommandParams {
    totemId: number;
    command: string;
    payload: Record<string, unknown>;
}

interface SendTotemCommandResponse {
    message: string;
    sentCommand: {
        totem_id: number;
        command: string;
        success: boolean;
    };
}

export function useSendTotemCommand() {
    const mutationFn = async (params: UseSendTotemCommandParams) => {
        if (!Number.isFinite(params.totemId) || params.totemId <= 0) {
            throw new Error('totemId inválido para envio de comando ao totem.');
        }

        if (!params.command?.trim()) {
            throw new Error(
                'command é obrigatório para envio de comando ao totem.',
            );
        }

        if (
            !params.payload ||
            typeof params.payload !== 'object' ||
            Array.isArray(params.payload)
        ) {
            throw new Error(
                'payload é obrigatório e deve ser um objeto para envio de comando ao totem.',
            );
        }

        const { data } = await api.post<SendTotemCommandResponse>(
            '/totem/send-totem-command',
            params,
        );

        return data;
    };

    return useMutation({
        mutationFn,
        mutationKey: [MUTATION_KEY_TOTEM_SEND_COMMAND],
    });
}
